var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWalletOpenEye = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/eye"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 41440567"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.5 11.0417C6.59091 15.2084 13.4091 15.2084 17.5 11.0417M17.5 9.79175C13.4091 5.62508 6.59091 5.62508 2.5 9.79175M12.0455 10.4167C12.0455 11.4523 11.1297 12.2917 10 12.2917C8.87033 12.2917 7.95455 11.4523 7.95455 10.4167C7.95455 9.38121 8.87033 8.54175 10 8.54175C11.1297 8.54175 12.0455 9.38121 12.0455 10.4167Z",
    stroke: "#73756D",
    strokeWidth: 2,
    strokeLinecap: "round"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWalletOpenEye);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/wallet_open_eye.fc42d1213e2ed63bdec22f425effa653.svg";